import {
  getCellphoneProducer,
  getEmailProducer,
  getNameProducer,
  getPictureProducer,
} from '@helpers/helper.properties'
import { ElementHTML } from '@helpers/helper.rendering'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Development, Property, RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  data: Development | Property
  from: string
  development?: Development
  property?: Property
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const Contact_1 = ({
  data,
  from,
  title,
  paragraph,
  underlineMode,
  is_wide,
  form,
  button,
  development,
  property,
  titleSecondary,
  global_data,
  showProducer,
  image,
  alignCenter,
  titleElement,
  subtitle,
  paragraphs,
  titleColor,
  titleHexa,
  paragraphElement,
  customBorderRadius,
  paragraphHexa,
  paragraphColor,
}: CombinedProps) => {
  const FormComponent = require(`@components/form/1`)?.default

  console.log(button)

  return (
    <Container fluid={is_wide ? false : true}>
      <Row className={'contacto-main e p-y-config ' + (is_wide ? 'is_wide_component' : '')}>
        <Col
          lg={is_wide ? 9 : 6}
          className="text-column mx-auto"
        >
          <ElementHTML
            className={`mb-4 pe-lg-5 section-name ${titleSecondary ? 'text-secondary' : ''} ${
              alignCenter ? ' text-center ' : ''
            } ${titleColor}`}
            children={title || 'Contacto'}
            elementType={titleElement || 'h2'}
            style={{ color: titleHexa || '#1f1f1f' }}
          />

          {
            paragraph &&
              paragraph.split('\n').map((paragraph_, index) => (
                <>
                  <ElementHTML
                    children={paragraph_ || ''}
                    className={titleColor + ' m-0'}
                    style={{ color: paragraphHexa || '#000' }}
                    elementType={paragraphElement || 'p'}
                    key={index + '-p'}
                  />
                </>
              ))
            // <p className={'mt-lg-3 mb-5 pe-lg-5 ' + (alignCenter ? ' text-center ' : '')}>
            //   {paragraph.split("")}
            // </p>
          }
          {property?.producer && showProducer ? (
            <>
              <div className="producer-wrapper d-flex align-items-start justify-content-start justify-content-lg-start mb-5 mb-lg-0">
                <div className="producer-text d-flex flex-column">
                  <div className="d-flex align-items-center mb-4 mb-lg-5">
                    {image && (
                      <img
                        className={'producer-img d-block me-4' + (image ? ' no-img' : '')}
                        src={image}
                        alt={getNameProducer(property) || 'producer-image'}
                      />
                    )}
                    {subtitle || paragraphs ? (
                      <div className="">
                        {subtitle && <h4>{subtitle}</h4>}
                        {paragraphs &&
                          paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="d-flex align-items-center">
                    <img
                      className={
                        'producer-img d-block me-4' +
                        (getPictureProducer(property)?.includes('static/img/user') ? ' no-img' : '')
                      }
                      src={getPictureProducer(property)}
                      alt={getNameProducer(property)}
                    />
                    <div>
                      <div className="div d-inline-block wrapper-contact">
                        <h4 className="text-uppercase">Contacto</h4>
                        <p>{getNameProducer(property)}</p>
                        <hr />
                      </div>
                      <p>
                        <a href={'mailto:' + getEmailProducer(property)}>
                          {getEmailProducer(property)}
                        </a>
                      </p>
                      <p className="d-flex align-items-center">
                        Tel <span className="separator mx-2"></span>{' '}
                        {getCellphoneProducer(property)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="producer-wrapper d-flex align-items-center justify-content-center justify-content-lg-start mb-5 mb-lg-0">
              <div className="producer-text d-flex flex-column mx-0">
                {subtitle && <h4 className="mt-3">{subtitle}</h4>}
                {paragraphs &&
                  paragraphs.map((paragraph, index) => (
                    <p
                      key={index}
                      style={paragraphColor ? { color: paragraphColor } : {}}
                    >
                      {paragraph}
                    </p>
                  ))}
              </div>
            </div>
          )}
        </Col>
        <Col
          lg={is_wide ? 9 : 6}
          className={`form-column ${is_wide ? 'mt-lg-5 pt-lg-3 mt-4 mx-auto' : ''}`}
        >
          <FormComponent
            data={data}
            underlineMode={underlineMode}
            from={from}
            button={button}
            development={development}
            property={property}
            global_data={global_data}
            customBorderRadius={customBorderRadius} // captcha={form?.captcha}
          />
          <div id="alert-message"></div>
        </Col>
      </Row>
    </Container>
  )
}
export default Contact_1
